/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateQueueSessionData,
    CreateQueueSessionDataFromJSON,
    CreateQueueSessionDataToJSON,
} from '../models/CreateQueueSessionData';
import {
    type CreateQueueSessionInput,
    CreateQueueSessionInputFromJSON,
    CreateQueueSessionInputToJSON,
} from '../models/CreateQueueSessionInput';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type ProjectPermissionInfo,
    ProjectPermissionInfoFromJSON,
    ProjectPermissionInfoToJSON,
} from '../models/ProjectPermissionInfo';
import {
    type ReadinessStatus,
    ReadinessStatusFromJSON,
    ReadinessStatusToJSON,
} from '../models/ReadinessStatus';
import {
    type RuntimeStatus,
    RuntimeStatusFromJSON,
    RuntimeStatusToJSON,
} from '../models/RuntimeStatus';
import {
    type SchedulerSessions200Response,
    SchedulerSessions200ResponseFromJSON,
    SchedulerSessions200ResponseToJSON,
} from '../models/SchedulerSessions200Response';
import {
    type SubscriptionPackageValues,
    SubscriptionPackageValuesFromJSON,
    SubscriptionPackageValuesToJSON,
} from '../models/SubscriptionPackageValues';
import {
    type SupportedCurrency,
    SupportedCurrencyFromJSON,
    SupportedCurrencyToJSON,
} from '../models/SupportedCurrency';

export interface SystemApiCreateSchedulerSessionRequest {
    createQueueSessionInput: CreateQueueSessionInput;
}

export interface SystemApiEnqueueIntegrationRequest {
    integrationId: string;
}

export interface SystemApiEnqueueProjectPrecalculationRequest {
    projectId: string;
}

export interface SystemApiRecoverStuckSchedulerSessionRequest {
    sessionId: string;
}

export interface SystemApiSchedulerSessionsRequest {
    page?: number;
    state?: SchedulerSessionsStateEnum;
    projectId?: string | null;
}

/**
 * 
 */
export class SystemApi extends runtime.BaseAPI {

    /**
     * Creates request options for applicationOpenAPISpecification without sending the request
     */
    async applicationOpenAPISpecificationRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/openapi`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns openapi json.
     */
    async applicationOpenAPISpecificationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.applicationOpenAPISpecificationRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns openapi json.
     */
    async applicationOpenAPISpecification(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.applicationOpenAPISpecificationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for applicationReadiness without sending the request
     */
    async applicationReadinessRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/readiness`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns whether the service is ready to receive traffic.
     */
    async applicationReadinessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadinessStatus>> {
        const requestOptions = await this.applicationReadinessRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadinessStatusFromJSON(jsonValue));
    }

    /**
     * Returns whether the service is ready to receive traffic.
     */
    async applicationReadiness(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadinessStatus> {
        const response = await this.applicationReadinessRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for applicationStatus without sending the request
     */
    async applicationStatusRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/status`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns quick info about the service.
     */
    async applicationStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RuntimeStatus>> {
        const requestOptions = await this.applicationStatusRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RuntimeStatusFromJSON(jsonValue));
    }

    /**
     * Returns quick info about the service.
     */
    async applicationStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RuntimeStatus> {
        const response = await this.applicationStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createSchedulerSession without sending the request
     */
    async createSchedulerSessionRequestOpts(requestParameters: SystemApiCreateSchedulerSessionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createQueueSessionInput'] == null) {
            throw new runtime.RequiredError(
                'createQueueSessionInput',
                'Required parameter "createQueueSessionInput" was null or undefined when calling createSchedulerSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/queue/sessions`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateQueueSessionInputToJSON(requestParameters['createQueueSessionInput']),
        };
    }

    /**
     * Schedules all eligible project integrations for a superadministrator-selected run mode and fetch window.
     */
    async createSchedulerSessionRaw(requestParameters: SystemApiCreateSchedulerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateQueueSessionData>> {
        const requestOptions = await this.createSchedulerSessionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateQueueSessionDataFromJSON(jsonValue));
    }

    /**
     * Schedules all eligible project integrations for a superadministrator-selected run mode and fetch window.
     */
    async createSchedulerSession(requestParameters: SystemApiCreateSchedulerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateQueueSessionData> {
        const response = await this.createSchedulerSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for debugException without sending the request
     */
    async debugExceptionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/debug/exception`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Throws a runtime exception for Tracy logging verification.
     */
    async debugExceptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.debugExceptionRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Throws a runtime exception for Tracy logging verification.
     */
    async debugException(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.debugExceptionRaw(initOverrides);
    }

    /**
     * Creates request options for defaultSubscriptionValues without sending the request
     */
    async defaultSubscriptionValuesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/subscription-default-values`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Default values if no subscription present.
     */
    async defaultSubscriptionValuesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubscriptionPackageValues>> {
        const requestOptions = await this.defaultSubscriptionValuesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubscriptionPackageValuesFromJSON(jsonValue));
    }

    /**
     * Default values if no subscription present.
     */
    async defaultSubscriptionValues(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubscriptionPackageValues> {
        const response = await this.defaultSubscriptionValuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for enqueueIntegration without sending the request
     */
    async enqueueIntegrationRequestOpts(requestParameters: SystemApiEnqueueIntegrationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling enqueueIntegration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/queue/integration/{integrationId}`;
        urlPath = urlPath.replace('{integrationId}', encodeURIComponent(String(requestParameters['integrationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Schedules a manual project run limited to the selected integration.
     */
    async enqueueIntegrationRaw(requestParameters: SystemApiEnqueueIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.enqueueIntegrationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Schedules a manual project run limited to the selected integration.
     */
    async enqueueIntegration(requestParameters: SystemApiEnqueueIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.enqueueIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for enqueueProjectPrecalculation without sending the request
     */
    async enqueueProjectPrecalculationRequestOpts(requestParameters: SystemApiEnqueueProjectPrecalculationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling enqueueProjectPrecalculation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/queue/precalculation/{projectId}`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Schedules a manual rebuild of published project data without fetch jobs.
     */
    async enqueueProjectPrecalculationRaw(requestParameters: SystemApiEnqueueProjectPrecalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.enqueueProjectPrecalculationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Schedules a manual rebuild of published project data without fetch jobs.
     */
    async enqueueProjectPrecalculation(requestParameters: SystemApiEnqueueProjectPrecalculationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.enqueueProjectPrecalculationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectPermissions without sending the request
     */
    async projectPermissionsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project-permission`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List of all available project permissions.
     */
    async projectPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectPermissionInfo>> {
        const requestOptions = await this.projectPermissionsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectPermissionInfoFromJSON(jsonValue));
    }

    /**
     * List of all available project permissions.
     */
    async projectPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectPermissionInfo> {
        const response = await this.projectPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for recoverStuckSchedulerSession without sending the request
     */
    async recoverStuckSchedulerSessionRequestOpts(requestParameters: SystemApiRecoverStuckSchedulerSessionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling recoverStuckSchedulerSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/queue/sessions/{sessionId}/recover`;
        urlPath = urlPath.replace('{sessionId}', encodeURIComponent(String(requestParameters['sessionId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Marks unfinished fetch jobs as failed and returns an abandoned session older than 30 minutes to the normal finalization queue.
     */
    async recoverStuckSchedulerSessionRaw(requestParameters: SystemApiRecoverStuckSchedulerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.recoverStuckSchedulerSessionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Marks unfinished fetch jobs as failed and returns an abandoned session older than 30 minutes to the normal finalization queue.
     */
    async recoverStuckSchedulerSession(requestParameters: SystemApiRecoverStuckSchedulerSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.recoverStuckSchedulerSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for schedulerSessions without sending the request
     */
    async schedulerSessionsRequestOpts(requestParameters: SystemApiSchedulerSessionsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/queue/sessions`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns paginated scheduler sessions with nested fetch jobs for admin overview.
     */
    async schedulerSessionsRaw(requestParameters: SystemApiSchedulerSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SchedulerSessions200Response>> {
        const requestOptions = await this.schedulerSessionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SchedulerSessions200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns paginated scheduler sessions with nested fetch jobs for admin overview.
     */
    async schedulerSessions(requestParameters: SystemApiSchedulerSessionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SchedulerSessions200Response> {
        const response = await this.schedulerSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for supportedCurrencies without sending the request
     */
    async supportedCurrenciesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/supported-currencies`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List of supported currencies.
     */
    async supportedCurrenciesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SupportedCurrency>>> {
        const requestOptions = await this.supportedCurrenciesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportedCurrencyFromJSON));
    }

    /**
     * List of supported currencies.
     */
    async supportedCurrencies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SupportedCurrency>> {
        const response = await this.supportedCurrenciesRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SchedulerSessionsStateEnum = {
    All: 'all',
    Scheduled: 'scheduled',
    Running: 'running',
    Completed: 'completed'
} as const;
export type SchedulerSessionsStateEnum = typeof SchedulerSessionsStateEnum[keyof typeof SchedulerSessionsStateEnum];
